/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedBriefcaseIcon20Light = forwardRef('MedBriefcaseIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.5 8.501a.5.5 0 0 0-1 0V10.5H7.502a.5.5 0 0 0 0 1H9.5v1.998a.5.5 0 1 0 1 0V11.5H12.5a.5.5 0 1 0 0-1H10.5V8.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3.75C6 2.784 6.784 2 7.75 2h4.5c.966 0 1.75.784 1.75 1.75V5h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h1V3.75Zm7 0V5H7V3.75A.75.75 0 0 1 7.75 3h4.5a.75.75 0 0 1 .75.75ZM5 6h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z" })));
});
